import { render, staticRenderFns } from "./QuotationsTable.vue?vue&type=template&id=f8d92fdc"
import script from "./QuotationsTable.vue?vue&type=script&lang=ts"
export * from "./QuotationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports